module.exports = __webpack_public_path__ + "assets/images/5e403c558f990ad7ead8fc6fb215b503.png";